function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.99679 7.16212C4.99874 6.94224 4.90945 6.72987 4.74695 6.56786L2.09116 4L4.74695 1.43214C4.90967 1.2706 5 1.05898 5 0.839314C5 0.61965 4.90967 0.408024 4.74695 0.246489C4.66913 0.168807 4.57449 0.10678 4.46907 0.0643464C4.36364 0.0219127 4.24971 0 4.13453 0C4.01935 0 3.90543 0.0219127 3.8 0.0643464C3.69457 0.10678 3.59994 0.168807 3.52211 0.246489L0.254222 3.40746C0.0908197 3.56834 0 3.77982 0 3.99943C0 4.21904 0.0908197 4.43052 0.254222 4.5914L3.51899 7.75351C3.59681 7.83119 3.69145 7.89322 3.79687 7.93565C3.9023 7.97809 4.01623 8 4.13141 8C4.24659 8 4.36051 7.97809 4.46594 7.93565C4.57137 7.89322 4.666 7.83119 4.74383 7.75351C4.90613 7.59253 4.99545 7.38111 4.99366 7.16212",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/arrow-left-3.931fb419.svg";
export { SvgComponent as ReactComponent };